export default __webpack_public_path__ + "static/media/card1.86a28906.png";